import React from "react";
import { useLang } from "../context/LangProvider";

export const TermsOfUse = () => {
  const { lang } = useLang();
  if (lang === "en") {
    return <EnTerms />;
  } else return <Terms />;
};

const EnTerms = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      flex: 1,
    }}
  >
    <div className="h4">Terms of Use</div>
    <div className="h6">Chapter 1. General Provisions</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 1 (Purpose)</p>
      <p className="h7">
        These Terms of Use (“Terms”) set forth the rights, obligations, and
        responsibilities between Limited Liability Company JH (the “Company”)
        and users in connection with the use of all services provided by the
        Company (the “Services”).
        <br />
        These Terms shall also apply, to the extent not inconsistent with their
        nature, to electronic commerce conducted via PC communications, wireless
        networks, and similar means.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 2 (Definitions)</p>
      <p className="h7">
        1. “Cyber Mall” means a virtual business place established by the
        Company to allow transactions of goods or services (“Products, etc.”) by
        using computers and other information and communications equipment, and
        may also refer to the operator of such Cyber Mall.
        <br />
        2. “User” means a member or non-member who accesses the Cyber Mall and
        receives Services provided by the Company pursuant to these Terms.
        <br />
        3. “Member” means a person who provides personal information to the
        Company to register and, thereby, continuously receives information from
        the Company and is able to use the Services on an ongoing basis.
        <br />
        4. “Non-member” means a person who uses the Services without registering
        as a Member.
        <br />
        5. Terms not defined herein shall be governed by relevant laws and
        service-specific guidelines.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">
        Article 3 (Disclosure, Explanation, and Amendment of the Terms)
      </p>
      <p className="h7">
        1. The Company shall post these Terms, together with the Company’s name,
        business address (including the address for handling consumer
        complaints), phone number, fax number, email address, business
        registration number, mail-order business report number, and the data
        protection officer’s details, on the initial screen (front page) of the
        Cyber Mall in a manner easily accessible to Users. The full text of the
        Terms may be made available through a linked page.
        <br />
        2. The Company may amend these Terms to the extent that such amendment
        does not violate applicable laws, including the Act on the Regulation of
        Terms and Conditions, the Act on Promotion of Information and
        Communications Network Utilization and Information Protection, the Act
        on Consumer Protection in Electronic Commerce, and the Framework Act on
        Consumers.
        <br />
        3. If the Company amends these Terms, it shall announce the effective
        date and reasons for amendment and post the current and amended Terms on
        the Company’s screen from at least seven (7) days prior to the effective
        date until the day before the effective date. However, where the
        amendments are unfavorable to Users, the Company shall provide at least
        thirty (30) days’ prior notice. In such case, the Company shall clearly
        compare and display the provisions before and after amendment.
        <br />
        4. Amended Terms shall apply only to contracts entered into on or after
        the effective date. Contracts concluded prior thereto shall remain
        subject to the former Terms. Notwithstanding the foregoing, if a User
        who has already concluded a contract wishes to have the amended Terms
        apply and obtains the Company’s consent by notifying the Company during
        the notice period under Paragraph 3, the amended Terms shall apply.
        <br />
        5. Matters not provided for herein and the interpretation hereof shall
        be governed by the Act on Consumer Protection in Electronic Commerce,
        the Act on the Regulation of Terms and Conditions, the Guidelines for
        Consumer Protection in Electronic Commerce set by the Korea Fair Trade
        Commission, and other relevant laws or commercial practices.
      </p>
    </div>

    <div className="h6">Chapter 2. Company’s Services</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">
        Article 4 (Provision and Modification of Services)
      </p>
      <p className="h7">
        1. The Company provides the following Services:
        <br />① Provision of information on Products, etc., and conclusion of
        purchase contracts
        <br />② Delivery of Products, etc., for which a purchase contract has
        been concluded
        <br />③ Other services determined by the Company
        <br />
        2. If Products, etc., become out of stock or technical specifications
        change so that provision is no longer possible, the Company may modify
        the content of Products, etc., to be provided under future contracts. In
        such case, the Company shall immediately post the modified content and
        date of provision at the location where the current Product information
        is posted.
        <br />
        3. If the content of a Service already contracted with a User must be
        changed due to reasons such as out-of-stock or changes in technical
        specifications, the Company shall immediately notify the User by a
        method reasonably capable of reaching the User.
        <br />
        4. In the foregoing case, the Company shall compensate the User for
        damages incurred; provided, however, that the Company shall bear no
        liability if it proves the absence of intent or negligence.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 5 (Suspension of Services)</p>
      <p className="h7">
        1. The Company may temporarily suspend the provision of Services upon
        occurrence of reasons beyond its reasonable control, including
        maintenance, replacement, or malfunction of computers or
        information-communications facilities, interruption of communications,
        acts of God, or force majeure.
        <br />
        2. In case of Service suspension under Paragraph 1, the Company shall
        notify Users in accordance with Article 8.
        <br />
        3. The Company shall not be liable for damages suffered by Users or
        third parties due to temporary suspension of Services under Paragraph 1
        unless caused by the Company’s intent or negligence.
      </p>
    </div>

    <div className="h6">Chapter 3. Service Use Agreement</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 6 (Membership Registration)</p>
      <p className="h7">
        1. Users may register as Cyber Mall members free of charge by completing
        the Company’s registration form with required information and indicating
        consent to these Terms.
        <br />
        2. Membership registration is completed when the Company accepts the
        application and grants a Service use account (the “Account”).
        <br />
        3. The Company shall register as Members those applicants who do not
        fall under any of the following:
        <br />① Applicants who previously lost membership under Article 7(3);
        provided that those for whom three (3) years have elapsed since loss of
        membership and whom the Company accepts for re-registration are
        excepted.
        <br />② Applications containing false information, omissions, or errors
        <br />③ Cases where, in the Company’s judgment, registering the
        applicant would cause significant technical impediment
        <br />④ Children under the age of fourteen (14)
        <br />
        4. Membership registration is completed when the Company’s acceptance
        reaches the applicant.
        <br />
        5. If a Member’s registered information changes, the Member shall
        promptly notify or update the Company by the method designated by the
        Company.
        <br />
        6. Each individual may hold only one (1) Account.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">
        Article 7 (Withdrawal and Disqualification of Membership)
      </p>
      <p className="h7">
        1. Members may request withdrawal at any time, and the Company shall
        promptly process the withdrawal.
        <br />
        <br />
        2. The Company may restrict or suspend membership if a Member:
        <br />① Registered false information upon application
        <br />② Fails to pay prices or other obligations related to the Services
        by the due date
        <br />③ Uses another person’s ID, password, or personal information
        <br />④ Interferes with another’s use of the Services or threatens
        e-commerce order by stealing information
        <br />⑤ Uses the Services for acts prohibited by law or these Terms or
        against public policy
        <br />⑥ Intentionally disrupts Service operations
        <br />⑦ Uses membership grades by improper means or for improper
        purposes
        <br />⑧ Habitually cancels or returns purchased Products, etc., without
        just cause thereby disrupting business
        <br />⑨ Purchases large quantities for resale in a way that disrupts the
        Company’s transactions
        <br />⑩ Acquires or uses Company-provided points improperly
        <br />
        3. If the same act recurs two (2) or more times after
        restriction/suspension or if the cause is not remedied within thirty
        (30) days, the Company may revoke membership.
        <br />
        4. Upon revocation, the Company shall delete the Member’s registration.
        The Company shall notify the Member and grant at least thirty (30) days
        prior to deletion for the Member to present an explanation.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 8 (Notice to Members)</p>
      <p className="h7">
        1. The Company may give notice to Members via the email address or
        mobile number registered by the Member.
        <br />
        2. For notices to an unspecified number of Members, the Company may
        substitute individual notice by posting on the Service bulletin board.
      </p>
    </div>

    <div className="h6">Chapter 4. Purchase Contracts and Payment</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 9 (Purchase Application)</p>
      <p className="h7">
        When applying to purchase through the Company by the following or
        substantially similar methods, the Company shall provide information in
        a manner easily understandable to Users:
        <br />- Search and selection of Products, etc.
        <br />- Entry of name, address, phone (or mobile) number, email address,
        etc.
        <br />- Confirmation of Terms, any limits on the right of withdrawal,
        and costs such as shipping or installation fees
        <br />- Submission of a purchase application and confirmation thereof or
        consent to the Company’s confirmation
        <br />- Selection of a payment method
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 10 (Formation of Purchase Contract)</p>
      <p className="h7">
        1. The Company may refuse acceptance of a purchase application in any of
        the following cases. In contracts with minors, the Company shall notify
        that the minor or legal representative may cancel the contract if
        consent of the legal representative is not obtained.
        <br />① Applications containing false information, omissions, or errors
        <br />② Purchase by a minor of goods or services prohibited under the
        Juvenile Protection Act (e.g., tobacco, alcohol)
        <br />③ Cases where acceptance would, in the Company’s judgment, cause
        significant technical impediment
        <br />④ Cases violating applicable laws or government guidelines
        <br />
        <br />
        2. A purchase contract is deemed formed when the Company’s acceptance
        reaches the User in the form of an acknowledgment of receipt under
        Article 12(1).
        <br />
        3. The Company’s acceptance shall include confirmation of the User’s
        application, availability for sale, and information regarding correction
        or cancellation of the application.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 11 (Methods of Payment)</p>
      <p className="h7">
        1. Prices for Products or services purchased through the Company may be
        paid by any of the following available methods, and the Company shall
        not charge any additional fees beyond the price of the Products, etc.:
        <br />① Account transfers (phone banking, internet banking, etc.)
        <br />② Various card payments (prepaid, debit, credit)
        <br />③ Online bank deposits without passbook
        <br />④ Electronic money
        <br />⑤ Points granted by the Company (e.g., mileage)
        <br />⑥ Gift certificates contracted with or recognized by the Company
        <br />⑦ Other electronic payment methods
        <br />
        <br />
        2. Information entered by the User for payment and any related
        responsibility rest with the User. If payment is not completed within a
        reasonable period after an order, the Company may cancel the order. 3.
        The Company may verify that the purchaser is duly authorized to use the
        selected payment method and, if necessary, suspend the transaction and
        request supporting materials.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">
        Article 12 (Acknowledgment of Receipt; Change and Cancellation of
        Purchase Application)
      </p>
      <p className="h7">
        1. When a User submits a purchase application, the Company shall issue
        an acknowledgment of receipt.
        <br />
        2. Upon receiving the acknowledgment, if there is any discrepancy in the
        User’s intent, the User may request immediate change or cancellation,
        and the Company shall handle such request without delay provided the
        request is made before shipment.
        <br />
        3. If the User has already paid the price, the provisions of Article 15
        on withdrawal of offer, etc., shall apply.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 13 (Supply of Products, etc.))</p>
      <p className="h7">
        1. Unless otherwise agreed with the User, the Company shall take
        necessary measures such as made-to-order processing and packaging to
        enable shipment of Products, etc., within seven (7) days from the date
        of the User’s offer; provided that if the Company has already received
        all or part of the price, such measures shall be taken within two (2)
        business days. The Company shall take appropriate measures to allow the
        User to check the supply procedures and progress.
        <br />
        2. Public holidays, other non-business days, or events of force majeure
        (e.g., natural disasters) shall be excluded from the delivery period.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 14 (Refunds)</p>
      <p className="h7">
        If the Company cannot deliver or provide the Products, etc., ordered by
        the User due to reasons such as out-of-stock, it shall notify the User
        without delay and, if the price was received in advance, refund it or
        take necessary measures for refund within three (3) business days from
        receipt.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 15 (Withdrawal of Offer, etc.)</p>
      <p className="h7">
        1. A User who has concluded a purchase contract with the Company may
        withdraw the offer within seven (7) days from receipt of the
        acknowledgment. If delivery occurs later than such receipt, the User may
        withdraw within seven (7) days from receipt of the Products, etc.
        <br />
        2. If the User has received the Products, etc., returns or exchanges
        shall not be permitted in the following cases:
        <br />① Where the value of the Products, etc., has significantly
        decreased due to use or partial consumption by the User
        <br />② Where the value has significantly decreased over time making
        resale difficult
        <br />③ Where the packaging of Products, etc., that can be reproduced to
        the same performance has been damaged
        <br />④ Other cases prescribed by Presidential Decree for transaction
        safety
        <br />
        <br />
        3. Notwithstanding Paragraph 2(②)-(④), if the Company did not clearly
        indicate restrictions on the right of withdrawal in a manner easily
        noticeable to consumers or provide samples for trial, the User’s right
        of withdrawal shall not be restricted.
        <br />
        4. Notwithstanding Paragraphs 1 and 2, if the Products, etc., differ
        from their labeling/advertising or are performed contrary to the
        contract, the User may withdraw within three (3) months from receipt or
        within thirty (30) days from the date the User became aware (or could
        have become aware) of such fact.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">
        Article 16 (Effects of Withdrawal of Offer, etc.)
      </p>
      <p className="h7">
        1. If the Company has received returned Products, etc., it shall refund
        amounts already paid within three (3) business days. If refund is
        delayed, the Company shall pay delay interest calculated at the rate
        announced by the Korea Fair Trade Commission.
        <br />
        2. Where payment was made by credit card or other means under the
        Electronic Financial Transactions Act, the Company shall promptly
        request the payment provider to suspend or cancel the charge.
        <br />
        3. In case of withdrawal, the User shall bear the costs necessary for
        returning the Products, etc. The Company shall not claim liquidated
        damages or compensation solely due to withdrawal. However, if withdrawal
        is due to inconsistency with labeling/advertising or non-conforming
        performance, the Company shall bear the return costs.
        <br />
        4. If the User paid shipping at the time of receipt, the Company shall
        clearly indicate, in an easily understandable manner, who bears such
        cost upon withdrawal.
      </p>
    </div>
    <div className="h6">Chapter 5. Obligations of the Parties</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">
        Article 17 (Protection and Use of Personal Information)
      </p>
      <p className="h7">
        1. The Company collects only the minimum personal information necessary
        to provide the Services; provided that personal identification
        information required to fulfill statutory obligations may be collected.
        <br />
        2. Where collecting personally identifiable information, the Company
        shall obtain the User’s consent.
        <br />
        3. Provided personal information shall not be used for purposes other
        than those consented to or provided to third parties without the User’s
        consent, and the Company bears responsibility therefor; except in the
        following cases:
        <br />① Provision to a delivery company of minimum information (name,
        address, mobile number) necessary for shipping
        <br />② Where obtaining ordinary consent is extremely difficult for
        economic or technical reasons and the information is necessary to
        perform the service contract
        <br />③ Where necessary for settlement of payments arising from
        transactions
        <br />④ Where necessary for identity verification to prevent fraudulent
        use
        <br />⑤ Where required by law or unavoidably necessary by law
        <br />⑥ Provision to a company handling customer inquiries/complaints of
        information necessary to perform such tasks
        <br />⑦ Provision to an affiliated partner, as consented at sign-up, of
        minimum information (name, mobile number, product reviews, etc.)
        necessary to perform the affiliated work and identity verification
        <br />
        <br />
        4. Where the Company must obtain consent under Paragraphs 2 and 3, it
        shall specify or notify in advance the identity of the data protection
        officer (department, name, phone and other contact details), purposes of
        collection/use, and matters relating to provision to third parties
        (recipient, purpose, and items provided) as required by Article 22 of
        the Act on Promotion of Information and Communications Network
        Utilization and Information Protection. Users may withdraw consent at
        any time.
        <br />
        5. Users may at any time request access to and correction of their
        personal information held by the Company, and the Company shall take
        necessary measures without delay. Where correction is requested, the
        Company shall not use the relevant information until correction is
        completed.
        <br />
        6. The Company shall limit and minimize the number of administrators for
        personal information protection and shall be liable for damages to Users
        arising from loss, theft, leakage, or alteration of Users’ personal
        information, including credit card and bank account information.
        <br />
        7. The Company or any third party that received personal information
        from the Company shall destroy such information without delay when the
        purpose of collection or provision is achieved.
        <br />
        8. Where the Company collects/uses/provides Members’ personal
        information, it shall obtain the Member’s consent pursuant to applicable
        laws.
        <br />
        9. Members may withdraw consent to collection and use of personal
        information at any time, which may be effected by membership withdrawal.
        <br />
        For details regarding personal information, see the Privacy Policy.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 18 (Obligations of the Company)</p>
      <p className="h7">
        1. The Company shall use best efforts to provide Products or services
        continuously and stably as set forth herein.
        <br />
        2. The Company shall have a security system to protect Users’ personal
        information (including credit information) to ensure safe use of
        Services.
        <br />
        3. If a User suffers damage due to labeling/advertising in violation of
        Article 3 of the Act on Fair Labeling and Advertising in connection with
        Products or services sold by the Company, the Company shall be liable
        for compensation.
        <br />
        4. The Company shall not send for-profit advertising emails to Users who
        have clearly expressed an intention to refuse receipt.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">
        Article 19 (Obligations Regarding Member Accounts)
      </p>
      <p className="h7">
        1. Except as provided in Article 18, Members are responsible for
        managing their Accounts and access credentials (ID and password).
        <br /> 2. All activities conducted through a Member’s Account (e.g.,
        purchases, postings) are deemed the activities of that Member. Members
        shall not lend or transfer their Accounts to others.
        <br />
        3. If a Member becomes aware of theft of ID/password or unauthorized use
        of the Account by a third party, the Member shall immediately notify the
        Company and follow any guidance.
        <br />
        4. The Company is not liable for damages arising from a Member’s breach
        of Paragraphs 1-3 unless caused by the Company’s intent or negligence.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 20 (User Obligations)</p>
      <p className="h7">
        1. Users shall comply with applicable laws, these Terms, user guides,
        and notices provided by the Company.
        <br />
        2. If a Member engages in any prohibited act under this Article, the
        Company may suspend all or part of the Services or terminate the Service
        agreement at its discretion and, if necessary, notify relevant
        governmental or judicial authorities.
        <br />
        3. Users shall not engage in the following acts:
        <br />① Register false information (including upon changes)
        <br />② Arbitrarily alter information posted on the Cyber Mall
        <br />③ Transmit or post information (e.g., computer programs) not
        permitted by the Company
        <br />④ Infringe copyrights or other intellectual property rights of the
        Company or third parties
        <br />⑤ Defame or interfere with the business of the Company or third
        parties
        <br />⑥ Publicly display or post obscene/violent messages, images, or
        audio or other content contrary to public morals
        <br />⑦ Repeated abnormal purchase activities that disrupt the Company’s
        business
        <br />⑧ Use third-party identity, card, account, or address information
        to use the Services
        <br />⑨ Verbally abuse or swear at customer-facing employees
        <br />⑩ Other illegal or unfair acts contrary to public morals
      </p>
    </div>

    <div className="h6">Chapter 6. Use of Ancillary Services</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 21 (Reward Points)</p>
      <p className="h7">
        1. The Company may grant points to Members upon product purchases,
        check-ins, etc. If a purchase is canceled or returned, the Company shall
        deduct the granted points. Specific operations are subject to the
        Company’s policies.
        <br />
        2. Points may be used as cash-equivalents for purchases under the
        applicable rules (except items pre-notified as ineligible), but are not
        refundable in cash and are non-transferable.
        <br />
        3. Points cannot be combined or moved between Accounts and may be used
        only via the Account to which they were granted.
        <br />
        4. Where a Member under fourteen (14) uses points, consent to use of
        points is deemed obtained through the legal representative’s consent at
        initial sign-up.
        <br />
        5. Points are valid for one (1) year (12 months) from the grant date and
        automatically expire if:
        <br />- The Member withdraws;
        <br />- One (1) year (12 months) has elapsed;
        <br />- No purchase activity occurs for one (1) year;
        <br />- Other separately notified conditions for use/expiration apply.
        <br />
        <br />
        6. If points were obtained by improper means, the Company may withdraw
        points, delete the Account, file a criminal complaint, and take other
        measures.
        <br />
        7. The Company may set different criteria for accrual, use methods,
        validity periods, and restrictions by product, membership grade, or
        reason for grant and will post or notify Users separately.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 22 (Coupons)</p>
      <p className="h7">
        1. The Company may issue coupons to Members using the purchase services,
        which may be exchanged for specified products or points.
        <br />
        2. “Coupons” collectively refer to point coupons, beverage/product
        exchange coupons, and any other coupons granting benefits within the
        Services.
        <br />
        3. Coupons may be used only by the Member for the Member’s own purchases
        via the Account to which they were issued and may not be sold or
        transferred to any third party under any circumstances.
        <br />
        4. Coupons cannot be combined or moved between Accounts and may be used
        only via the issuing Account.
        <br />
        5. Coupons may be restricted by item, amount, or per-Member quantity and
        may not be used after the expiration date.
        <br />
        6. If a purchase made using a coupon is canceled or returned and a
        refund is issued, the coupon is, in principle, reusable; however, some
        coupons may be non-reusable, and reuse may be restricted under the
        Company’s policies in cases such as cancellation due to change of mind.
        <br />
        7. Upon membership withdrawal, all coupons expire immediately.
      </p>
    </div>

    <div className="h6">Chapter 7. Miscellaneous</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">
        Article 23 (Ownership of Intellectual Property Rights and Use of Works)
      </p>
      <p className="h7">
        1. All rights, including intellectual property rights, in and to the
        Services provided by the Company belong to the Company.
        <br />
        2. Unless otherwise indicated, all rights (including copyrights) in
        videos, photos, posts, and hashtags used or created by Members in the
        course of using the Services (“Posts, etc.”) belong to the respective
        Members.
        <br />
        3. Users shall not use or allow a third party to use, for commercial
        purposes, information obtained through the Services by reproduction,
        transmission, publication, distribution, broadcasting, or other methods
        without the Company’s prior consent.
        <br />
        4. Posts, etc., may be exposed via the Company’s websites and mobile
        applications, search results, or related promotions. For such exposure,
        Posts may be modified or edited in a limited manner (e.g., resizing or
        simplifying without content change). The Company will comply with
        copyright laws, and Members may delete or make private their Posts via
        customer service or in-service management features.
        <br />
        5. Members grant the Company permission to use their Posts, etc.,
        domestically and internationally for the following purposes:
        <br />① Reproduction, transmission, and display within the Services
        (including where the Services are provided within areas of third-party
        sites or media) and limited modifications such as resizing without
        changing content for exposure of featured Posts
        <br />② For publicity of the Services, allowing media/press to report or
        broadcast all or part of Posts; provided that the Company will not
        provide Member information to such media without the Member’s separate
        consent
        <br />
        <br />
        For policy reasons or integration among Services, the Company may change
        or move the posting location of Posts, upon prior notice.
        <br />
        If a Member terminates the use agreement or the Company terminates it,
        the Member’s Posts will be deleted; provided that Posts re-posted by
        other Members or necessary for normal use of public Services may not be
        deleted.
        <br />
        The Company shall obtain the Member’s prior consent for any use of Posts
        beyond the foregoing.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">
        Article 24 (Management of Posts and Restrictions on Use)
      </p>
      <p className="h7">
        1. The right to manage and operate all Posts and content within the
        Services belongs to the creator or posting Member, who may manage their
        Posts via provided functions (delete, edit, etc.). Upon request by a
        Member or where deemed necessary for smooth operation, the Company may
        improve or support management-related matters.
        <br />
        2. If Posts violate applicable laws or infringe third-party rights
        (e.g., privacy or reputation), the Company may suspend posting or delete
        such Posts pursuant to applicable laws or upon a legitimate
        right-holder’s request.
        <br />
        3. If Posts fall under any of the following, the Company may, after
        prior notice (or without prior notice if permitted by law), delete or
        modify them even without a report from a Member/third party, and shall
        not be liable for deletion/modification unless caused by the Company’s
        intent or gross negligence:
        <br />① Defamation or slander of the Company, other Members, or third
        parties
        <br />② Violation of public order or morals
        <br />③ Content associated with criminal acts
        <br />④ Infringement of copyrights or other rights of the Company or
        third parties
        <br />⑤ Content unrelated to the Services
        <br />⑥ Unauthorized commercial advertising or promotions
        <br />⑦ Posts created by stealing others’ IDs, names, etc., or by
        unauthorized alteration of others’ input
        <br />⑧ Repetitive postings of identical content contrary to posting
        purposes
        <br />⑨ Other violations of relevant laws
        <br />
        <br />
        4. If a Member’s publicly available Post infringes another’s privacy or
        reputation under the Act on Promotion of Information and Communications
        Network Utilization and Information Protection, the affected
        Member/third party may request deletion or rebuttal posting by proving
        the infringement. If it is difficult to determine infringement or a
        dispute is anticipated, the Company shall take a temporary measure
        (“Temporary Measure”) to restrict access for a period set by the
        Company.
        <br />
        5. Where the author requests restoration of a temporarily restricted
        Post (“Reposting Request”), if both the author and applicant for
        deletion consent, the Company may request deliberation by the Korea
        Communications Standards Commission on defamation; if consent is not
        given, the Company shall determine whether to restore. If a decision is
        made within the Temporary Measure period, the decision shall be
        followed; otherwise, the Post will be restored after the period. If no
        Reposting Request is made, the Post will be deleted after the period.
        <br />
        6. Where another Member or third party takes civil/criminal action
        (e.g., criminal complaint, injunction or damages suit) against a Member
        or the Company due to a Post, the Company may restrict access to the
        Post until a final court judgment. The burden to prove legal action and
        final judgment lies with the requester.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 25 (Links to Other Sites)</p>
      <p className="h7">
        1. The Company may link to other sites via hyperlinks (including text,
        images, and videos).
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">
        Article 26 (Provision of Information and Posting of Advertisements)
      </p>
      <p className="h7">
        1. In operating the Services, the Company may provide various
        information on the Service screen or by email or postal mail.
        <br />
        2. The Company may post advertisements on the homepage, Service screens,
        text messages, or emails.
        <br />
        3. Communications or transactions arising between a Member and an
        advertiser through such advertisements are solely between the Member and
        the advertiser. Any disputes shall be resolved directly between them.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 27 (Dispute Resolution)</p>
      <p className="h7">
        1. The Company operates a customer center to reflect legitimate
        opinions/complaints and compensate for damages.
        <br />
        2. The Company gives priority to handling complaints and opinions
        submitted by Users and, if prompt handling is difficult, will
        immediately notify the User of the reason and schedule.
        <br />
        3. If a User seeks relief for a dispute related to electronic commerce
        between the Company and the User, the matter may be submitted to a
        dispute mediation agency commissioned by the Korea Fair Trade Commission
        or city/provincial governors.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">Article 29 (Jurisdiction and Governing Law)</p>
      <p className="h7">
        1. Litigation concerning electronic commerce disputes between the
        Company and a User shall be brought before the district court having
        jurisdiction over the User’s address at the time of filing; if there is
        no address, then the court having jurisdiction over the place of
        residence; provided that if the address or residence is unclear or the
        User resides abroad, the competent court shall be determined under the
        Civil Procedure Act.
        <br />
        2. Korean law shall govern litigation arising between the Company and a
        User regarding electronic commerce.
        <br />
        <br />
        이용약관 버전번호 : v1.0
        <br />
        Effective Date: October 30, 2025
      </p>
    </div>
  </div>
);

const Terms = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      flex: 1,
    }}
  >
    <div className="h4">이용약관</div>
    <div className="h6">제 1장 총 칙</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 1조 (목적)</p>
      <p className="h7">
        본 이용약관은 유한회사 그랑핸드(이하 “회사”)에서 제공하는 모든
        서비스(이하 "서비스")를 이용함에 있어 회사와 이용자의 권리·의무카드드 및
        책임사항을 규정함을 목적으로 합니다.
        <br />
        PC통신, 무선 등을 이용하는 전자상거래에 대해서도 그 성질에 반하지 않는
        한 이 약관을 준용합니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 2조 (정의)</p>
      <p className="h7">
        1. "사이버몰"이란 회사가 재화 또는 용역(이하 "재화 등")을 이용자에게
        제공하기 위하여 컴퓨터 등 정보통신 설비를 이용하여 재화 등을 거래할 수
        있도록 설정한 가상의 영업장을 말하며, 아울러 사이버 몰을 운영하는
        사업자의 의미로도 사용합니다.
        <br />
        2. "이용자"란 사이버몰에 접속하여 이 약관에 따라 회사가 제공하는
        서비스를 받는 회원 및 비회원을 말합니다.
        <br />
        3. "회원"이라 함은 회사에 개인정보를 제공하여 회원 등록을 한 자로서,
        회사의 정보를 지속적으로 제공 받으며, 회사가 제공하는 서비스를
        계속적으로 이용할 수 있는 자를 말합니다.
        <br />
        4. "비회원"이라 함은 회원에 가입하지 않고 회사가 제공하는 서비스를
        이용하는 자를 말합니다.
        <br />
        5. 이외에 이 약관에서 사용하는 용어의 정의는 관계 법령 및 서비스 별
        안내에서 정하는 바에 의합니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 3조 (약관 등의 명시와 설명 및 개정)</p>
      <p className="h7">
        1. 회사는 이 약관의 내용과 상호, 영업소 소재지 주소(소비자의 불만을
        처리할 수 있는 곳의 주소를 포함), 전화번호, 모사전송번호, 이메일주소,
        사업자등록번호, 통신판매업신고번호, 개인정보관리책임자 등을 이용자가
        쉽게 알 수 있도록 사이버몰의 초기 서비스화면(전면)에 게시합니다. 다만,
        약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.
        <br />
        2. 회사는 『약관의 규제에 관한 법률』, 『정보통신망 이용촉진 및 정보보호
        등에 관한 법률』, 『전자상거래 등에서의 소비자보호에 관한 법률』,
        『소비자기본법』 등 관련법을 위배하지 않는 범위 에서 이 약관을 개정할 수
        있습니다.
        <br />
        3. 회사는 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여
        현행약관과 회사의 화면에 그 적용일자 7일 이전부터 적용일자 전일까지
        공지합니다. 다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는
        최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 회사는
        개정전 내용과 개정후 내용을 명확하게 비교하여 이용자가 알기 쉽도록
        표시합니다.
        <br />
        4. 회사가 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에
        체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정
        전의 약관조항이 그대로 적용됩니다. 다만 이미 계약을 체결한 이용자가
        개정약관 조항의 적용을 받기를 원하는 뜻을 제4항에 의한 개정약관의
        공지기간 내에 회사에 송신하여 회사의 동의를 받은 경우에는 개정약관
        조항이 적용됩니다.
        <br />
        5. 이 약관에서 정하지 아니한 내용과 이 약관의 해석에 관하여는
        『전자상거래 등에서의 소비자보호에 관한 법률』, 『약관의 규제에 관한
        법률』, 공정거래위원회가 정하는 『전자상거래 등에서의 소비자보호지침』
        및 관계법령 또는 상관례에 따릅니다.
      </p>
    </div>

    <div className="h6">제 2장 회사의 서비스</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 4조 (서비스의 제공 및 변경)</p>
      <p className="h7">
        1. 회사는 다음과 같은 서비스를 제공합니다.
        <br />① 재화 또는 용역에 대한 정보 제공 및 구매 계약의 체결
        <br />② 구매 계약이 체결된 재화 또는 용역의 배송
        <br />③ 기타 회사가 정하는 업무
        <br />
        2. 회사는 상품 또는 용역이 품절되거나 기술적 사양의 변경 등으로 더 이상
        제공할 수 없는 경우에는 장차 체결되는 계약에 의해 제공할 상품, 용역의
        내용을 변경할 수 있습니다. 이 경우에는 변경된 재화 또는 용역의 내용 및
        제공일자를 명시하여 현재의 재화 또는 용역의 내용을 게시한 곳에 즉시
        공지합니다.
        <br />
        3. 회사가 제공하기로 이용자와 계약을 체결한 서비스의 내용을 상품 등의
        품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를
        이용자에게 통지 가능한 방법으로 즉시 통지합니다.
        <br />
        4. 전항의 경우 회사는 이로 인하여 이용자가 입은 손해를 배상합니다. 다만,
        회사가 고의 또는 과실이 없음을 입증한 경우에는 아무런 책임을 부담하지
        않습니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 5조 (서비스의 중단)</p>
      <p className="h7">
        1. 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절,
        천재지변, 불가항력, 기타 회사의 합리적인 통제범위를 벗어난 사유가 발생한
        경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.
        <br />
        2. 제1항에 의한 서비스 중단의 경우에는 회사는 제8조에 정한 방법으로
        이용자에게 통지합니다.
        <br />
        3. 회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여
        이용자 또는 제3자가 입은 손해에 대하여 회사의 고의 또는 과실이 없는 한
        손해를 배상하지 아니합니다.
      </p>
    </div>

    <div className="h6">제 3장 서비스 이용계약</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 6조 (회원가입)</p>
      <p className="h7">
        1. 이용자는 무료로 사이버몰 회원에 가입할 수 있으며, 회사가 정한 가입
        양식에 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서
        회원가입을 신청합니다.
        <br />
        2. 회사는 회원가입 신청에 대한 승낙을 통해 회원가입 절차를 완료하고
        회사의 서비스 이용 계정(이하 "계정")을 부여합니다.
        <br />
        3. 회사는 제1항에 따라 회원가입을 신청한 이용자 중 다음 각 호에 해당하지
        않는 한 회원으로 등록합니다.
        <br />① 가입신청자가 이 약관 제7조 제3항에 의하여 이전에 회원자격을
        상실한 적이 있는 경우, 다만 제7조 제3항에 의한 회원자격 상실 후 3년이
        경과한 자로서 회사가 회원 재가입을 승낙한 경우는 예외로 합니다.
        <br />② 등록 내용에 허위, 기재누락, 오기가 있는 경우
        <br />③ 기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고
        판단되는 경우
        <br />④ 만 14세 미만의 아동
        <br />
        4. 회원가입은 회사의 승낙이 가입 신청한 이용자에게 도달한 때에
        완료됩니다.
        <br />
        5. 회원은 회사에 등록한 회원정보에 변경이 있는 경우, 즉시 회사에서
        정하는 방법에 따라 해당 변경사항을 회사에 통지하거나 수정하여야 합니다.
        <br />
        6. 회원은 1인 당 1개의 계정만 가입할 수 있습니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 7조 (회원 탈퇴 및 자격 상실 등)</p>
      <p className="h7">
        1. 회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원
        탈퇴를 처리합니다.
        <br />
        2. 회원이 다음 각호의 사유에 해당하는 경우, 회사는 회원 자격을 제한 및
        정지시킬 수 있습니다.
        <br />① 가입 신청 시에 허위 내용을 등록한 경우
        <br />② 회사의 서비스를 이용하여 구입한 재화 등의 대금, 기타 회사의
        서비스 이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우
        <br />③ 타인의 ID와 비밀번호 또는 그 개인정보를 도용한 경우
        <br />④ 다른 사람의 회사의 서비스 이용을 방해하거나 그 정보를 도용하는
        등 전자상거래 질서를 위협하는 경우
        <br />⑤ 회사를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는
        행위를 하는 경우
        <br />⑥ 기타 서비스 운영을 고의로 방해하는 행위를 하는 경우
        <br />⑦ 회원 등급을 부정한 방법 또는 목적으로 사용한 경우
        <br />⑧ 회사를 통해 구매한 재화 등을 정당한 이유없이 상습적으로 취소
        또는 반품하는 등의 방법으로 업무를 방해하는 경우
        <br />⑨ 재판매 목적으로 재화 등을 대량으로 중복 구매하여 회사의 거래를
        방해한 경우
        <br />⑩ 부정 적립, 부정 사용 등 회사가 제공한 적립금을 부정한 방법 또는
        목적으로 이용한 경우
        <br />
        3. 회사가 회원 자격을 제한, 정지 시킨 후, 동일한 행위가 2회 이상
        반복되거나 30일 이내에 그 사유가 시정 되지 아니하는 경우 회사는 회원
        자격을 상실시킬 수 있습니다.
        <br />
        4. 회사가 회원 자격을 상실시키는 경우에는 회원 등록을 말소합니다. 이
        경우 회원에게 이를 통지하고, 회원 등록 말소 전에 최소한 30일 이상의
        기간을 정하여 소명할 기회를 부여합니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 8조 (회원에 대한 통지)</p>
      <p className="h7">
        1. 회원에 대한 통지를 하는 경우 회사는 회원이 등록한 e-mail 주소 또는
        휴대폰 번호 등으로 할 수 있습니다.
        <br />
        2. 회사는 불특정 다수 회원에 대한 통지의 경우 서비스 게시판 등에
        게시함으로써 개별 통지에 갈음할 수 있습니다.
      </p>
    </div>

    <div className="h6">제 4장 구매계약 및 대금 결제</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 9조 (구매신청)</p>
      <p className="h7">
        이용자는 회사에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며,
        회사는 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게
        제공하여야 합니다.
        <br />- 재화 등의 검색 및 선택
        <br />- 성명, 주소, 전화번호(또는 휴대폰번호), 이메일 주소 등의 입력
        <br />- 약관내용, 청약 철회권이 제한되는 서비스, 배송료, 설치비 등의
        비용부담과 관련한 내용에 대한 확인
        <br />- 재화 등의 구매신청 및 이에 관한 확인 또는 회사의 확인에 대한
        동의
        <br />- 결제 방법의 선택
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 10조 (구매계약의 성립)</p>
      <p className="h7">
        1. 회사는 제9조 구매신청에 대하여 다음 각 호에 해당하면 승낙하지 않을 수
        있습니다. 다만, 미성년자와 계약을 체결하는 경우에는 법정대리인의 동의를
        얻지 못하면 미성년자 본인 또는 법정대리인이 계약을 취소할 수 있다는
        내용을 고지하여야 합니다.
        <br />① 신청 내용에 허위, 기재누락, 오기가 있는 경우
        <br />② 미성년자가 담배, 주류 등 청소년보호법에서 금지하는 상품 및
        용역을 구매하는 경우
        <br />③ 기타 구매신청을 승낙하는 것이 회사 기술상 현저히 지장이 있다고
        판단하는 경우
        <br />④ 기타 제반 법령 및 정부의 가이드라인에 위반되는 경우
        <br />
        2. 회사의 승낙이 제12조 제1항의 수신확인 통지형태로 이용자에게 도달한
        시점에 구매계약이 성립한 것으로 봅니다.
        <br />
        3. 회사의 승낙의 의사표시에는 이용자의 구매신청에 대한 확인 및 판매가능
        여부, 구매신청의 정정 취소 등에 관한 정보 등을 포함하여야 합니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 11조 (지급방법)</p>
      <p className="h7">
        1. 회사에서 구매한 상품 또는 용역에 대한 대금지급방법은 다음 각 호의
        방법 중 가용한 방법으로 할 수 있습니다. 단, 회사는 이용자의 지급방법에
        대하여 재화 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수
        없습니다.
        <br />① 폰뱅킹, 인터넷뱅킹 등의 각종 계좌이체
        <br />② 선불카드, 직불카드, 신용카드 등의 각종 카드 결제
        <br />③ 온라인 무통장입금
        <br />④ 전자 화폐에 의한 결제
        <br />⑤ 마일리지 등 회사가 지급한 포인트에 의한 결제
        <br />⑥ 회사와 계약을 맺었거나 회사가 인정한 상품권에 의한 결제
        <br />⑦ 기타 전자적 지급 방법에 의한 대금 지급 등<br />
        2. 구매대금의 결제와 관련하여 이용자가 입력한 정보 및 그와 관련된 책임은
        이용자에게 있으며, 재화 또는 용역의 청약 후 합리적인 일정 기간 내에
        결제가 이루어 지지 않는 경우 회사는 이에 해당주문을 취소할 수 있습니다.
        <br />
        3. 회사는 구매자의 결제수단에 대하여 정당한 사용권한 보유여부를 확인할
        수 있으며 필요한 경우 해당 거래진행의 정지 및 소명자료의 제출을 요청할
        수 있습니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 12조 (수신확인통지·구매신청 변경 및 취소)</p>
      <p className="h7">
        1. 회사는 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를
        합니다.
        <br />
        2. 수신확인 통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는
        수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고,
        회사는 배송 전에 이용자의 요청이 있는 경우에는 지체 없이 그 요청에 따라
        처리하여야 합니다.
        <br />
        3. 수신확인 통지를 받은 이용자가 대금을 지불한 경우에는 제 15조의
        청약철회 등에 관한 규정에 따릅니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 13조 (재화 등의 공급)</p>
      <p className="h7">
        1. 회사는 이용자와 재화 등의 공급시기에 관하여 별도의 약정이 없는 이상,
        이용자가 청약을 한 날로부터 7일 이내에 재화 등을 배송할 수 있도록
        주문제작, 포장 등 기타의 필요한 조치를 취합니다. 다만, 회사가 이미 재화
        등의 대금의 전부 또는 일부를 받은 날부터 2영업일 이내에 조치를 취합니다.
        이때 회사는 이용자가 재화 등의 공급 절차 및 진행 사항을 확인 할 수
        있도록 적절한 조치를 합니다.
        <br />
        2. 공휴일 및 기타 휴무일 또는 천재지변 등의 불가항력적 사유가 발생하는
        경우 그 해당기한은 배송소요기간에서 제외합니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 14조 (환급)</p>
      <p className="h7">
        회사는 이용자가 구매 신청한 재화 등이 품절 등의 사유로 인도 또는 제공을
        할 수 없을 때에는 지체 없이 그 사유를 이용자에게 통지하고 사전에 재화
        등의 대금을 받은 경우에는 대금을 받은 날부터 3영업일 이내에 환급하거나
        환급에 필요한 조치를 취합니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 15조 (청약 철회 등)</p>
      <p className="h7">
        1. 회사와 재화 등의 구매에 관한 계약을 체결한 이용자는 수신확인의 통지를
        받은 날로부터 7일 이내에 청약의 철회를 할 수 있습니다. 다만, 통지를 받은
        때보다 공급이 늦게 이루어진 경우에는 재화 등의 공급을 받은 날로부터 7일
        이내에 청약 철회를 할 수 있습니다.
        <br />
        2. 이용자는 재화 등을 배송 받은 경우 다음 각호에 해당하는 경우에는 반품
        및 교환을 할 수 없습니다.
        <br />① 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히
        감소한 경우
        <br />② 시간의 경과에 의하여 재판매가 곤란할 정도로 재화 등의 가치가
        현저히 감소한 경우
        <br />③ 같은 성능을 지닌 재화 등으로 복제가 가능한 경우 그 원본인 재화
        등의 포장을 훼손한 경우
        <br />④ 그 밖에 거래의 안전을 위하여 대통령령이 정하는 경우
        <br />
        3. 제2항 제2호 내지 제4호의 경우에는 회사가 사전에 청약 철회 등이
        제한되는 사실을 소비자가 쉽게 알 수 있는 곳에 명기하거나 시용 상품을
        제공하는 등의 조치를 하지 않았다면 이용자의 청약 철회 등이 제한되지
        않습니다.
        <br />
        4. 이용자는 제1항 및 제2항의 규정에도 불구하고 재화 등의 내용이 표시,
        광고 내용과 다르거나 계약 내용과 다르게 이행된 때에는 당해 재화 등을
        공급받은 날부터 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터
        30일 이내에 청약 철회 등을 할 수 있습니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 16조 (청약 철회 등의 효과)</p>
      <p className="h7">
        1. 회사는 이용자로부터 재화 등을 반환 받은 경우 3영업일 이내에 이미
        지급받은 재화 등의 대금을 환급 합니다. 이 경우 회사가 이용자에게 재화
        등의 환급을 지연한 때에는 그 지연 기간에 대하여 공정거래위원회가 정하여
        고시하는 지연 이자율을 곱하여 산정한 지연 이자를 지급합니다.
        <br />
        2. 회사는 위 대금을 환급함에 있어서 구매자가 신용카드 또는
        전자금융거래법 등이 정하는 결제수단으로 재화 등의 대금을 지급한 때에는
        지체 없이 당해 결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를
        정지 또는 취소하도록 요청할 수 있습니다.
        <br />
        3. 청약 철회 등의 경우 공급 받은 재화 등의 반환에 필요한 비용은 이용자가
        부담합니다. 회사는 이용자에게 청약 철회 등을 이유로 위약금 또는
        손해배상을 청구하지 않습니다. 다만 재화 등의 내용이 표시, 광고 내용과
        다르거나 계약 내용과 다르게 이행되어 청약 철회 등을 하는 경우 재화 등의
        반환에 필요한 비용은 회사가 부담합니다.
        <br />
        4. 이용자가 재화 등을 제공받을 때 발송비를 부담한 경우에 회사는 청약
        철회 시 그 비용을 누가 부담하는지를 알기 쉽도록 명확하게 표시합니다.
      </p>
    </div>

    <div className="h6">제 5장 계약당사자의 의무</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 17조 (개인정보보호 및 이용)</p>
      <p className="h7">
        1. 회사는 이용자의 정보수집 시 서비스의 제공에 필요한 최소한의 정보를
        수집합니다. 다만 관련 법령상 의무이행을 위하여 본인확인이 필요한 경우
        해당 개인정보를 수집합니다.
        <br />
        2. 회사는 이용자의 개인 식별이 가능한 개인 정보를 수집하는 때에는 반드시
        당해 이용자의 동의를 받습니다.
        <br />
        3. 제공된 개인정보는 당해 이용자의 동의 없이 목적 외의 이용이나
        제3자에게 제공할 수 없으며, 이에 대한 모든 책임은 회사가 집니다. 다만,
        다음의 경우는 예외로 합니다.
        <br />① 배송 업무상 배송 업체에게 배송에 필요한 최소한의 이용자의
        정보(성명, 주소, 휴대폰 번호)를 알려주는 경우
        <br />② 정보통신서비스의 제공에 관한 계약의 이행을 위하여 필요한
        개인정보로서 경제적, 기술적인 사유로 통상의 동의를 받는 것이 현저히
        곤란한 경우
        <br />③ 재화 등의 거래에 따른 대금 정산을 위하여 필요한 경우
        <br />④ 도용 방지를 위하여 본인 확인에 필요한 경우
        <br />⑤ 법률의 규정 또는 법률에 의하여 필요한 불가피한 사유가 있는 경우
        <br />⑥ 신속한 이용문의 상담 및 이용자의 불만처리 업무를 대행하는 회사에
        상담업무에 필요한 이용자의 정보를 제공하는 경우
        <br />⑦ 회원가입 시 동의한 제휴사별 제휴 업무 진행을 위한 필요로 하는
        본인확인을 위한 최소한의 정보(성명, 휴대폰 번호, 주문상품평 등)를
        제휴사에게 제공하는 경우
        <br />
        4. 회사가 제2항과 제3항에 의해 이용자의 동의를 받아야 하는 경우에는
        개인정보관리 책임자의 신원(소속, 성명 및 전화번호, 기타 연락처), 정보의
        수집 목적 및 이용 목적, 제3자에 대한 정보 제공 관련 사항(제공 받은자,
        제공 목적 및 제공할 정보의 내용) 등 정보통신망이용촉진등에관한법률
        제22조 등에서 규정한 사항을 미리 명시하거나 고지해야 하며 이용자는
        언제든지 이 동의를 철회할 수 있습니다.
        <br />
        5. 이용자는 언제든지 회사가 가지고 있는 자신의 개인 정보에 대해 열람 및
        오류 정정을 요구할 수 있으며 회사는 이에 대해 지체 없이 필요한 조치를
        취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 회사는 그
        오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.
        <br />
        6. 회사는 개인정보 보호를 위하여 관리자를 한정하여 그 수를 최소화 하며
        신용카드, 은행계좌 등을 포함한 이용자의 개인정보의 분실, 도난, 유출,
        변조 등으로 인한 이용자의 손해에 대하여 모든 책임을 집니다.
        <br />
        7. 회사 또는 그로부터 개인 정보를 제공받는 제3자는 개인정보의 수집 목적
        또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다.
        <br />
        8. 회사가 회원의 개인정보를 수집, 이용, 제공 등을 할 경우에는 정보통신망
        이용촉진 및 정보보호등에 관한 법률에 따라 회원의 동의를 받습니다.
        <br />
        9. 회원은 원하는 경우 언제든 회사에 제공한 개인정보의 수집과 이용에 대한
        동의를 철회할 수 있으며 동의의 철회는 회원 탈퇴를 하는 것으로 이루어
        집니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 18조 (회사의 의무)</p>
      <p className="h7">
        1. 회사는 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 상품 또는
        용역을 제공하는데 최선을 다합니다.
        <br />
        2. 회사는 이용자가 안전하게 서비스를 이용할 수 있도록 이용자의
        개인정보(신용정보 포함) 보호를 위한 보안 시스템을 갖추어야 합니다.
        <br />
        3. 회사는 판매하는 상품이나 용역에 대하여 『표시·광고의 공정화에 관한
        법률』 제3조의 규정에 위반하는 표시·광고행위를 함으로써 이용자가 손해를
        입은 때에는 이를 배상할 책임을 부담합니다.
        <br />
        4. 회사는 수신거절의 의사를 명백히 표시한 이용자에 대해서는 영리목적의
        광고성 이메일을 발송하지 않습니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 19조 (회원의 계정에 대한 의무)</p>
      <p className="h7">
        1. 제18조의 경우를 제외하고, 회원의 계정 및 계정에 접속할 수 있는
        정보(ID, 비밀번호)에 관한 관리책임은 회원에게 있습니다.
        <br />
        2. 회원의 계정을 통해 일어난 구매, 게시글 작성 등의 모든 활동은 계정을
        소유한 회원의 활동으로 간주합니다. 따라서 회원은 본인의 계정을 타인에게
        대여 또는 양도할 수 없습니다.
        <br />
        3. 회원이 자신의 ID 및 비밀번호를 도난 당하거나 제3자가 계정을 사용하고
        있음을 인지한 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우에는
        그에 따라야 합니다.
        <br />
        4. 회사는 회원이 상기 제1항, 제2항, 제3항을 위반하여 회원에게 발생한
        손해에 대하여 그 손해 발생의 원인이 회사의 고의 또는 과실에 기인하지
        않는 한 책임을 부담하지 않습니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 20조 (이용자의 의무)</p>
      <p className="h7">
        1. 이용자는 관계법령, 이 약관의 규정, 이용안내 등 회사가 통지하는 사항을
        준수하여야 합니다.
        <br />
        2. 회사는 회원이 본 조의 금지행위를 행하는 경우 서비스의 일부 또는
        전부를 이용 정지하거나 서비스 이용계약을 임의로 해지할 수 있습니다.
        회사는 필요한 경우 회원의 금지행위 사실을 관련 정부기관 또는 사법기관에
        통지할 수 있습니다.
        <br />
        3. 이용자는 회사의 서비스이용과 관련하여 다음 각호의 행위를 하여서는
        안됩니다.
        <br />① 개인정보의 등록(변경의 경우를 포함함) 시 허위내용을 등록
        <br />② 회사의 사이버몰에 게시된 정보를 임의로 변경
        <br />③ 회사가 허락하지 않은 정보(컴퓨터 프로그램 등)의 송신 또는 게시
        <br />④ 회사 기타 제3자의 저작권 등 지적재산권에 대한 침해
        <br />⑤ 회사 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
        <br />⑥ 외설 또는 폭력적인 메시지·화상·음성 기타 공서양속에 반하는
        정보를 화면에 공개 또는 게시하는 행위
        <br />⑦ 반복적인 비정상적 구매행위로 회사의 영업을 방해하는 행위
        <br />⑧ 타인의 명의, 카드정보, 계좌정보, 주소정보 등 제3자 정보를
        도용하여 회사가 제공하는 서비스를 이용하는 행위
        <br />⑨ 고객응대근로자에게 폭언 욕설을 하는 행위
        <br />⑩ 기타 공서양속에 위배되는 불법적이거나 부당한 행위
      </p>
    </div>

    <div className="h6">제 6장 부가서비스의 이용</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 21조 (적립 포인트)</p>
      <p className="h7">
        1. 회사는 회원이 상품을 구매하거나, 출석체크 참여 등의 경우 회원에게
        일정한 포인트를 부여할 수 있습니다. 다만, 상품구매 후 취소 또는 반품을
        할 경우에는 상품 구매 시 회사가 부여한 적립 포인트를 회수합니다. 이 외
        구체적인 운영방법은 회사의 운영정책에 의합니다.
        <br />
        2. 적립 포인트는 상품 구매시 사용가능 기준 하에 현금가액과 동일하게
        사용할 수 있으나 (단 사용불가 사전고지품목 제외), 현금으로 환불되지는
        않습니다. 또한, 적립 포인트는 회원에게만 제공되며 타인에게 양도할 수
        없습니다.
        <br />
        3. 계정간 적립 포인트 합산 및 이동은 불가하며 적립 포인트가 부여된
        계정을 통해서만 사용 가능합니다.
        <br />
        4. 만 14세 미만의 미성년자 회원이 적립 포인트를 사용하는 경우, 최초
        회원가입 시 법정대리인의 동의를 통해 회원 가입을 완료한 것으로 적립
        포인트 사용에 대한 법정대리인의 동의도 획득한 것으로 간주합니다.
        <br />
        5. 부여된 적립 포인트는 부여일로부터 1년(12개월)간 유효하며 다음의 경우
        적립금이 자동적으로 소멸하게 됩니다.
        <br />① 회원을 탈퇴한 경우
        <br />② 유효기간인 1년(12개월)이 지난 경우
        <br />③ 1년간 구매 활동이 없을 경우
        <br />④ 적립금 사용가능 조건 및 소멸에 대한 내용이 별도로 공지되는 경우
        <br />
        6. 부정한 방법으로 적립 포인트를 획득한 사실이 확인될 경우 회사는 회원의
        포인트 회수, 계정 삭제 및 형사 고발 등 기타 조치를 취할 수 있습니다.
        <br />
        7. 회사는 적립 포인트의 적립기준, 사용방법, 사용기한 및 제한 등을 상품,
        회원 등급 및 지급 사유 등에 따라 다르게 정할 수 있으며, 이용자에게
        별도로 게시하거나 통지합니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 22조 (쿠폰)</p>
      <p className="h7">
        1. 회사는 구매서비스를 이용하는 회원에게 지정된 상품 및 적립금으로
        교환할 수 있는 쿠폰을 발급할 수 있습니다.
        <br />
        2. 쿠폰은 적립금 쿠폰, 음료 및 상품 교환 쿠폰 및 기타 회사의 서비스 내
        혜택을 주는 모든 쿠폰을 통칭합니다.
        <br />
        3. 회원은 쿠폰이 발급된 계정을 통해 회원 본인의 구매에 한해서만 사용할
        수 있으며, 어떠한 경우에도 이를 타인에게 실질적으로 매매 또는 양도할 수
        없습니다.
        <br />
        4. 계정간 쿠폰의 합산 및 이동이 불가하며 쿠폰이 발급된 계정을 통해서만
        사용 가능합니다.
        <br />
        5. 쿠폰은 일부 품목이나 금액 또는 회원별 사용가능 수량에 따라 사용이
        제한될 수 있으며, 유효기간이 지난 후에는 사용할 수 없습니다.
        <br />
        6. 쿠폰을 사용하여 상품을 구입한 후 취소나 반품으로 인하여 환불이
        이루어진 경우에는 원칙적으로 쿠폰의 재사용이 가능하나, 재사용이 불가능한
        일부 쿠폰 및 단순변심에 의한 구매취소 등의 경우에는 회사의 운영정책에
        따라 재사용이 불가할 수 있습니다.
        <br />
        7. 회원을 탈퇴할 경우 쿠폰은 즉시 소멸됩니다.
      </p>
    </div>

    <div className="h6">제 7장 기타</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 23조 (저작권의 귀속 및 저작물의 이용)</p>
      <p className="h7">
        1. 회사가 회원에게 제공하는 서비스에 대한 지식재산권을 포함한 일체의
        권리는 회사에 귀속됩니다.
        <br />
        2. 회원이 서비스를 이용하는 과정에서 사용한 동영상 또는 사진, 작성한
        게시물 및 해시태그 등(이하 “게시물 등”이라 합니다)에 대한 저작권을
        포함한 일체의 권리는 별도의 의사표시가 없는 한 각 회원에게 귀속됩니다.
        <br />
        3. 이용자는 서비스를 이용함으로써 얻은 정보를 회사의 사전 승낙 없이
        복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리 목적으로 이용하거나
        제3자에게 이용하게 하여서는 안됩니다.
        <br />
        4. 게시물 등은 회사가 운영하는 인터넷 사이트 및 모바일 애플리케이션을
        통해 노출될 수 있으며, 검색 결과 또는 관련 프로모션 등에도 노출될 수
        있습니다. 또한, 해당 노출을 위해 필요한 범위 내에서는 일부 수정,
        편집되어 게시될 수 있습니다. 이 경우, 회사는 저작권법 규정을 준수하며,
        회원은 언제든지 고객센터 또는 각 서비스 내 관리기능을 통해 해당 게시물
        등에 대해 삭제, 비공개 등의 조치를 취할 수 있습니다.
        <br />
        5. 회원은 자신이 서비스에 게시한 게시물 등을 회사가 국내ㆍ외에서 다음 각
        호의 목적으로 사용하는 것을 허락합니다.
        <br />① 서비스(서비스가 제3자가 운영하는 사이트 또는 미디어의 일정 영역
        내에 입점하는 형태로 제공되는 경우 포함) 내에서 게시물 등의
        복제·전송·전시 및 우수 게시물을 서비스 화면에 노출하기 위하여 게시물의
        내용 변경 없이 크기를 변환하거나 단순화하는 등의 방식으로 수정하는 것
        <br />② 회사의 서비스를 홍보하기 위한 목적으로 미디어·통신사 등에
        게시물의 전부 또는 일부를 보도·방영하게 하는 것. 이 경우 회사는 회원의
        개별 동의 없이 미디어·통신사 등에게 회원정보를 제공하지 않음
        <br />
        6. 회사는 서비스의 정책 또는 회사가 운영하는 서비스 간 통합 등의 사유로
        게시물의 게재 위치를 변경·이전할 수 있으며, 이 경우 사전에 공지합니다.
        <br />
        7. 회원이 이용계약을 해지하거나, 회사가 이용계약을 해지하는 경우, 회원이
        서비스에 게시한 게시물은 삭제됩니다. 다만, 다른 회원 또는 제3자에게
        의하여 다시 게시된 게시물 등 공용 서비스 내에 게재되어 다른 회원의
        정상적인 서비스 이용에 필요한 게시물은 삭제되지 않습니다.
        <br />
        8. 회사는 전항 이외의 방법으로 회원의 게시물 등을 이용하고자 하는
        경우에는 사전에 회원의 동의를 얻습니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 24조 (게시물의 관리 및 이용 제한)</p>
      <p className="h7">
        1. 서비스 내 모든 게시물 및 콘텐츠의 관리와 운영 권한은 작가 또는 해당
        게시물 및 콘텐츠를 게시한 회원에게 있으며, 회원은 콘텐츠 삭제, 수정 등의
        관리 기능이 제공되는 경우 이를 통하여 직접 자신의 게시물을 관리할 수
        있습니다. 단, 회원의 요청이 있거나 기타 회사가 서비스의 원활한 운영을
        위하여 필요하다고 판단되는 경우, 회사는 게시물의 관리 등과 관련한 사항을
        개선, 지원하는 등의 활동을 할 수 있습니다.
        <br />
        2. 회원의 게시물 등이 관련 법령에 위반되는 내용을 포함하거나 서비스 내에
        게시된 게시물 등이 사생활 침해 또는 명예훼손 등 제3자의 권리를
        침해한다고 인정하는 경우 회사는 해당 관련 법령이나 적법한 권리자의
        요청에 따라 해당 게시물 등에 대한 게시중단 및 삭제 등의 조치를 취할 수
        있습니다.
        <br />
        3. 회사는 회원이 서비스 내에 게시한 게시물(회원 간 전달 포함)이 다음 각
        호의 경우에 해당한다고 판단되는 경우 회원 또는 제3자의 신고가 없어도
        사전 통지 후(단,관련 볍령에서 정하고 있는 경우 사전통지 없이) 삭제,
        변경할 수 있으며, 회사는 회원의 게시물로 인한 피해 발생의 원인이 회사의
        고의 또는 중과실에 기인하지 않는 한 게시물의 삭제, 변경에 대한 책임을
        지지 않습니다.
        <br />① 회사, 다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를
        손상시키는 내용인 경우
        <br />② 공공질서 및 미풍양속에 위반되는 내용의 게시물에 해당하는 경우
        <br />③ 게시물의 내용이 범죄적 행위에 결부된다고 인정되는 내용인 경우
        <br />④ 회사의 저작권, 제3자의 저작권 등 기타 타인의 권리를 침해하는
        내용인 경우
        <br />⑤ 회사에서 제공하는 서비스와 관련 없는 내용인 경우
        <br />⑥ 불필요하거나 승인되지 않은 상업적 목적의 광고, 판촉물을 게재하는
        경우
        <br />⑦ 타인의 ID, 명의 등을 무단으로 도용하여 작성한 내용이거나, 타인이
        입력한 정보를 무단으로 위ㆍ변조한 내용인 경우
        <br />⑧ 동일한 내용을 중복하여 다수 게시하는 등 게시의 목적에 어긋나는
        경우
        <br />
        ⑨기타 관계 법령에 위반되는 경우
        <br />
        4. 정보통신망 이용촉진 및 정보보호 등에 관한 법률의 규정에 의해 다른
        회원의 공개된 게시물 등이 본인의 사생활을 침해하거나 명예를 훼손하는 등
        권리를 침해 받은 회원 또는 제3자는 그 침해사실을 소명하여 회사에 해당
        게시물 등의 삭제 또는 반박 내용의 게재를 요청할 수 있습니다. 이 경우
        회사는 해당 게시물 등의 권리 침해 여부를 판단할 수 없거나 당사자 간의
        다툼이 예상되는 경우 해당 게시물 등에 대한 접근을 임시적으로 차단하는
        조치(이하 “임시조치”라 합니다)를 회사가 정한 임시조치 기간 동안
        취합니다.
        <br />
        5. 본인의 게시물 등이 임시적으로 차단된 회원은 회사에 해당 게시물 등을
        복원해 줄 것을 요청(이하 “재게시 청구”라 합니다)할 수 있으며, 회사는
        임시조치된 게시물의 명예훼손 등 판단에 대한 방송통신심의위원회 심의
        요청에 대한 게시자 및 삭제 등 신청인의 동의가 있는 경우 게시자 및 삭제
        등 신청인을 대리하여 이를 요청하고 동의가 없는 경우 회사가 이를 판단하여
        게시물 등의 복원 여부를 결정합니다. 게시자의 재게시 청구가 있는 경우
        임시조치 기간 내에 방송통신심의위원회 또는 회사의 결정이 있으면 그
        결정에 따르고 그 결정이 임시조치 기간 내에 있지 않는 경우 해당 게시물
        등은 임시조치 만료일 이후 복원됩니다. 재게시 청구가 없는 경우 해당
        게시물 등은 임시조치 기간 만료 이후 삭제됩니다.
        <br />
        6. 회원의 게시물 등으로 인한 법률상 이익 침해를 근거로, 다른 회원 또는
        제3자가 회원 또는 회사를 대상으로 하여 민·형사상의 법적 조치(예:
        형사고소, 가처분 신청∙손해배상청구 등 민사소송의 제기)를 취하는 경우,
        회사는 동 법적 조치의 결과인 법원의 확정판결이 있을 때까지 관련 게시물
        등에 대한 접근을 잠정적으로 제한할 수 있습니다. 게시물 등의 접근 제한과
        관련한 법적 조치의 소명, 법원의 확정 판결에 대한 소명 책임은 게시물 등에
        대한 조치를 요청하는 자가 부담합니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 25조 (사이트의 연결)</p>
      <p className="h7">
        1. 회사에서 하이퍼링크(하이퍼링크의 대상에는 문자, 그림 및 동화상 등이
        포함됨)방식을 통해 타 사이트에 연결시킬 수 있습니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 26조 (정보의 제공 및 광고의 게재)</p>
      <p className="h7">
        1. 회사는 서비스를 운영함에 있어 각종 정보를 서비스 화면에 게재하거나
        e-mail 및 서신우편 등의 방법으로 회원에게 제공할 수 있습니다.
        <br />
        2. 회사는 서비스의 운영과 관련하여 홈페이지, 서비스 화면, 문자메시지,
        e-mail 등에 광고 등을 게재할 수 있습니다.
        <br />
        3. 회원이 서비스상에 게재되어 있는 광고를 이용하거나 서비스를 통한
        광고주의 판촉활동에 참여하는 등의 방법으로 교신 또는 거래를 하는 것은
        회원과 광고주간의 거래이므로, 회원과 광고주간에 문제가 발생할 경우
        회원과 광고주가 직접 해결합니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 27조 (분쟁해결)</p>
      <p className="h7">
        1. 회사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를
        보상처리하기 위하여 고객센터를 운영합니다.
        <br />
        2. 회사는 이용자로부터 제출되는 불만사항 및 의견을 우선적으로
        처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와
        처리일정을 즉시 통보합니다.
        <br />
        3. 회사와 이용자간에 발생한 전자상거래 분쟁과 관련하여 이용자의
        피해구제신청이 있는 경우에는 공정거래위원회 또는 시・도지사가 의뢰하는
        분쟁조정기관의 조정에 따를 수 있습니다.
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <p className="h7 bold">제 28조 (재판권 및 준거법)</p>
      <p className="h7">
        1. 회사와 이용자간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의
        이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의
        전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지
        않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다.
        <br />
        2. 회사와 이용자간에 제기된 전자상거래 소송에는 대한민국법을 적용합니다.
        <br />
        <br />
        이용약관 버전번호 : v1.0
        <br />
        현재 이용약관 고지일자 : 2025년 10월 30일
        <br />
        현재 이용약관 시행일자 : 2025년 10월 30일
      </p>
    </div>
  </div>
);

const LineBreaks = ({ text }) => {
  const parts = String(text ?? "").split("\n");
  return (
    <>
      {parts.map((p, i) => (
        <React.Fragment key={i}>
          {p}
          {i < parts.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
};

const ENDATA = [
  {
    category: "Upon Membership Registration (Membership Service Management)",
    purpose:
      "Verify membership intent, identify and authenticate members, maintain and manage membership status, prevent fraudulent or unauthorized use, verify age, confirm consent of legal guardian for minors under 14, deliver notices",
    items:
      "Name, Date of Birth, Email Address, Telephone Number, Gender, Login ID, Password, Mobile Number, Legal Guardian’s Information (for users under 14)",
    retention:
      "Until membership withdrawal (may be retained up to 1 year thereafter to prevent fraudulent reuse, resolve disputes, or cooperate with legal authorities)",
    required: "Required",
  },
  {
    category: "During Service Use",
    purpose:
      "Order, purchase, and payment processing, delivery or invoice dispatch, financial transaction authentication and related services, content provision",
    items:
      "Name, Phone Number, Shipping Address, Order Details, Payment Information",
    retention: "Same as above",
    required: "Required",
  },
  {
    category: "During Customer Service",
    purpose: "Customer inquiries, complaints, and other issue resolution",
    items: "Name, Contact Number, Inquiry Details",
    retention: "Same as above",
    required: "Required",
  },
  {
    category: "Marketing and Advertising",
    purpose:
      "Deliver promotional or event information, send newsletters, analyze service usage frequency, compile statistical data on member activity",
    items: "Name, Email Address",
    retention: "Until withdrawal of consent or membership termination",
    required: "Optional",
  },
];

const DATA = [
  {
    category: "회원가입시\n(회원서비스 운영)",
    purpose:
      "회원 가입사실 확인, 회원제 서비스 이용에 따른 본인 식별 및 인증, 회원자격 유지 및 관리, 서비스 부정이용 방지",
    items: "이름, 이메일 주소, 전화번호, 성별, 로그인 ID",
    retention:
      "회원 탈퇴 시까지(불량회원의 부정한 이용의 재발을 방지, 분쟁해결 및 수사기관의 요청에 따른 협조가 필요한 경우 해지시로부터 1년까지)",
    required: "필수",
  },
  {
    category: "서비스 이용시",
    purpose:
      "주문, 구매 및 요금 결제 처리, 물품배송 또는 청구지 등 발송, 금융거래 본인 인증 및 금융서비스",
    items: "이름, 전화번호, 배송지 주소, 주문내역, 결제 정보",
    retention: "전자상거래법상 보유 및 이용기간(5년)",
    required: "필수",
  },
  {
    category: "고객 상담시",
    purpose: "상품에 관한 고객상담",
    items: "이름, 전화번호(연락처), 상담 내용",
    retention: "전자상거래법 보유 및 이용기간(3년)",
    required: "필수",
  },
  {
    category: "마케팅 및 광고 활용",
    purpose: "이벤트 등 광고성 정보 전달",
    items: "이름, 이메일",
    retention: "회원 탈퇴 또는 동의 철회 시까지",
    required: "옵션",
  },
];

const PROVIDER_DATA = [
  {
    provider: "스티비",
    purpose: "뉴스레터 발송",
    items: "이름, 이메일",
    period: "수신거부 시 또는 개인정보 제3자 제공 철회시까지",
  },
];

const ENCOLS = [
  { key: "category", title: "Category", width: 140 },
  { key: "purpose", title: "Purpose of Collection", width: 250 },
  { key: "items", title: "Items Collected", width: 250 },
  { key: "retention", title: "Retention Period", width: 250 },
  { key: "required", title: "Required/Optional", width: 100 },
];

const COLS = [
  { key: "category", title: "구 분", width: 140 },
  { key: "purpose", title: "수집 목적", width: 250 },
  { key: "items", title: "수집 항목", width: 250 },
  { key: "retention", title: "보유 및 이용기간", width: 250 },
  { key: "required", title: "필수/선택", width: 100 },
];

const PROVIDER_COLS = [
  { key: "provider", title: "제공받는 자", width: 140 },
  { key: "purpose", title: "제공목적", width: 140 },
  { key: "items", title: "제공항목", width: 140 },
  { key: "period", title: "보유 및 이용기간", width: 140 },
];

/** 공용 테이블 컴포넌트 */
const SimpleTable = ({ cols, rows }) => (
  <div style={{ overflowX: "auto" }}>
    <table className="gh-table">
      <thead>
        <tr>
          {cols.map((c) => (
            <th key={c.key} style={{ width: c.width }}>
              {c.title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i} className={i % 2 === 1 ? "zebra" : undefined}>
            {cols.map((c) => (
              <td key={c.key}>
                <LineBreaks text={r[c.key]} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const Privacy = () => {
  const { lang } = useLang();
  if (lang === "en") {
    return <EnPrivacy />;
  } else return <KoPrivacy />;
};

const EnPrivacy = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      flex: 1,
    }}
  >
    <div className="h4">Privacy Policy of JH Co., Ltd.</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h7">
        JH Co., Ltd. (hereinafter referred to as the "Company") values your
        personal information and complies with the “Act on Promotion of
        Information and Communications Network Utilization and Information
        Protection.”
        <br />
        Through this Privacy Policy, the Company informs customers of how their
        personal information is used and managed, and what protective measures
        are taken to ensure its security.
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">
        ■ Items of Personal Information Collected, Methods of Collection, and
        Purposes of Use
      </div>
      <div className="h7 bold">A. Items of Personal Information Collected</div>
      <div className="h7">
        The Company collects the following personal information for purposes
        such as membership registration, order processing, customer service,
        marketing and advertising, and service quality improvement.
      </div>

      {/* 표 1 */}
      <SimpleTable cols={ENCOLS} rows={ENDATA} />

      <div className="h7">
        o During service usage or business operations, information such as
        service usage records, access logs, cookies, IP addresses, payment
        records, and history of fraudulent usage may also be automatically
        collected.
      </div>

      <div className="h7 bold">B. Methods of Collection</div>
      <div className="h7">
        - Website, written forms, bulletin boards, email, event applications,
        delivery requests, phone, fax, and automatic data collection tools
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">
          ■ Retention and Use Period of Personal Information
        </div>
        <div className="h7">
          In principle, personal information is destroyed without delay once the
          purpose of its collection and use has been achieved. However, the
          following information is retained for the reasons and periods
          specified below.
        </div>
        <div className="h7">
          <LineBreaks
            text={`A. Retention Based on Company Policy
Personal information is retained until membership withdrawal. However, even after withdrawal, it may be retained for up to one (1) year to prevent fraudulent reuse, resolve disputes, or cooperate with legal investigations.`}
          />
        </div>
        <div className="h7">
          <LineBreaks
            text={`B. Retention Based on Applicable Laws
              When necessary in accordance with relevant laws such as the “Act on Consumer Protection in Electronic Commerce,” the Company retains certain information for a specified period:
o Records related to contracts or cancellations
- Reason for retention: Act on Consumer Protection in Electronic Commerce
- Retention period: 5 years
o Records related to payment and supply of goods/services
- Reason for retention: Act on Consumer Protection in Electronic Commerce
- Retention period: 5 years
o Records related to consumer complaints or dispute resolution
- Reason for retention: Act on Consumer Protection in Electronic Commerce
- Retention period: 3 years
o Log records
- Reason for retention: Protection of Communications Secrets Act
- Retention period: 3 months
`}
          />
        </div>
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">
        ■ Destruction Procedure and Method of Personal Information
      </div>
      <div className="h7">
        <LineBreaks
          text={`The Company destroys personal information without delay when the purpose of its collection and use has been fulfilled or when retention is no longer necessary.
            If a user withdraws consent to collection/use of personal information (e.g., through membership withdrawal or contract termination), the Company promptly destroys the collected data. However, information may still be retained for up to one (1) year for dispute resolution or legal cooperation.`}
        />
      </div>
      <div className="h7">
        <LineBreaks
          text={`o Destruction Procedure
The Company selects personal information to be destroyed, obtains approval from the Data Protection Officer, and proceeds with destruction.`}
        />
      </div>
      <div className="h7">
        <LineBreaks
          text={`o Destruction Method
Electronic files: Deleted using technical methods that make recovery impossible.
Paper documents: Destroyed through shredding or incineration.
`}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">
          ■ Provision of Personal Information to Third Parties
        </div>
        <div className="h7">
          <LineBreaks
            text={`The Company processes personal information only within the purposes specified above and does not provide personal information to third parties, except in cases permitted by law under Articles 17 and 18 of the Personal Information Protection Act.`}
          />
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">
          ■ Outsourcing of Collected Personal Information
        </div>
        <div className="h7">
          <LineBreaks
            text={`The Company entrusts certain personal information processing tasks to specialized external service providers for smoother service operation.
o Entrusted Party: Jimpool Co., Ltd.
o Task: Fulfillment services (storage, packaging, shipment)

o Entrusted Party: Toss Payments Co., Ltd.
o Task: Payment processing services

o Entrusted Party: Naver Financial Corp.
o Task: Payment processing services

o Entrusted Party: BankDa Co., Ltd.
o Task: Automated bank transfer verification and deposit processing

o Entrusted Party: CJ Logistics Corp.
o Task: Delivery services

o Entrusted Party: Channel Corporation
o Task: Customer service operations

o Entrusted Party: Stibee Co., Ltd.
o Task: Email and newsletter delivery services

o Entrusted Party: I’mweb Co., Ltd.
o Task: Website hosting and infrastructure services

o Entrusted Party: Dream Security Co., Ltd.
o Task: Identity verification services

o Entrusted Party: Growing Sales Co., Ltd.
o Task: Mobile application development and operational management services

When entering into outsourcing contracts, the Company specifies the prohibition of personal information use beyond the intended purpose, requirements for security and management, restrictions on subcontracting, supervision of entrusted parties, and liability for damages. The Company monitors and supervises entrusted parties to ensure compliance.
If there are any changes to the entrusted tasks or recipients, the Company will promptly notify users through this Privacy Policy.`}
          />
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">■ Rights of Users and Legal Representatives</div>
        <div className="h7">
          The Company does not accept membership from, nor collect personal
          information of, children under the age of 14.
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">
          ■ Measures for Ensuring the Security of Personal Information
        </div>
        <div className="h7">
          <LineBreaks
            text={`In accordance with Article 29 of the Personal Information Protection Act and Article 30 of its Enforcement Decree, the Company takes the following administrative, technical, and physical measures:

O Administrative Measures

Establishment and enforcement of internal management plans and guidelines, regular employee training

O Technical Measures

Access control and authorization management

Installation of access control systems

Encryption of passwords and payment data

Installation and updates of security programs

SSL encryption for secure data transmission
`}
          />
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">
          ■ Installation, Operation, and Refusal of Automatic Data Collection
          Devices (Cookies)
        </div>
        <div className="h7">
          <LineBreaks
            text={`The Company uses cookies—small text files stored on your device by the server—to improve service quality and provide personalized services.`}
          />
        </div>
        <div className="h7">
          회사은(는) 다음과 같은 목적을 위해 쿠키를 사용합니다.
        </div>
        <div className="h7">
          <LineBreaks
            text={`o 쿠키 등 사용 목적
1. 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공
2. 귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.`}
          />
        </div>
        <div className="h7">
          <LineBreaks
            text={`o Purpose of Cookies
Analyze connection frequency and visit duration, identify user preferences and interests, track event participation and visits, and provide customized marketing and services.
Users can choose to allow all cookies, be prompted each time, or refuse all cookies through their browser settings.
o How to Refuse Cookies
You may refuse cookies through your web browser settings: allow all cookies, confirm each time, or block all cookies.
Example (Internet Explorer): Tools > Internet Options > Privacy
However, refusing cookies may limit service functionality.
`}
          />
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">
          ■ Personal Information Inquiries and Complaints
        </div>
        <div className="h7">
          <LineBreaks
            text={`The Company designates the following departments and personnel to handle privacy-related inquiries and complaints.
Customer Service Department
- Phone: 02-333-6525
- Email: hello@granhand.com

Data Protection Officer
- Name: Jiho Jeong
- Department: Online Team
- Phone: 02-333-6525
- Email: hello@granhand.com
`}
          />
        </div>
        <div className="h7">
          <LineBreaks
            text={`o Users may report any privacy-related complaints to the above contacts. The Company will respond promptly and sincerely.
o Users may also seek assistance or dispute resolution through the following institutions:
Personal Information Infringement Report Center (privacy.kisa.or.kr / 118)
Personal Information Dispute Mediation Committee (kopico.go.kr / 1833-6972)
Supreme Prosecutors’ Office Cyber Investigation Division (spo.go.kr / local area code +1301)
National Police Agency Cyber Bureau (cyberbureau.police.go.kr / 182)
`}
          />
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">
          ■ Notification of Changes to the Privacy Policy
        </div>
        <div className="h7">
          This Privacy Policy takes effect from the date below. If there are
          additions, deletions, or amendments in accordance with laws or
          internal policies, the Company will notify users at least 7 days prior
          (or 30 days prior if significant changes to user rights occur) through
          the website or email. If advance notice is impracticable, notification
          will be made as soon as possible.
        </div>
        <div className="h7">- Effective Date: October 30, 2025</div>
      </div>
    </div>
  </div>
);

const KoPrivacy = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      flex: 1,
    }}
  >
    <div className="h4">개인정보처리방침</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h7">
        <LineBreaks
          text={`그랑핸드 (이하 "회사"는) 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다.
회사는 개인정보처리방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.`}
        />
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">■ 수집하는 개인정보 항목 및 수집방법</div>
      <div className="h7 bold">가. 수집하는 개인정보의 항목</div>
      <div className="h7">
        <LineBreaks
          text={`o 회사는 회원가입, 주문 처리, 고객 상담, 마케팅 및 광고, 서비스 품질 개선을 위해 아래와 같은 개인정보를 수집하고 있습니다.
- 회원가입시 : 이름 , 생년월일 , 성별 , 로그인ID , 비밀번호 , 휴대전화번호 , 이메일 , 14세미만 가입자의 경우 법정대리인의 정보
- 서비스 신청시 : 주소, 결제 정보`}
        />
      </div>

      {/* 표 1 */}
      <SimpleTable cols={COLS} rows={DATA} />

      <div className="h7">
        o 서비스 이용 과정이나 사업 처리 과정에서 서비스이용기록, 접속로그,
        쿠키, 접속 IP, 결제 기록, 불량이용 기록이 생성되어 수집될 수 있습니다.
      </div>

      <div className="h7 bold">나. 수집방법</div>
      <div className="h7">
        - 홈페이지, 서면양식, 게시판, 이메일, 이벤트 응모, 배송요청, 전화, 팩스,
        생성 정보 수집 툴을 통한 수집
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">■ 개인정보의 수집 및 이용목적</div>
      <div className="h7">
        회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
      </div>
      <div className="h7">
        <LineBreaks
          text={`o 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산콘텐츠 제공 , 구매 및 요금 결제 , 물품배송 또는 청구지 등 발송 , 금융거래 본인 인증 및 금융 서비스
o 회원 관리회원제 서비스 이용에 따른 본인확인 , 개인 식별 , 불량회원의 부정 이용 방지와 비인가 사용 방지 , 가입 의사 확인 , 연령확인 , 만14세 미만 아동 개인정보 수집 시 법정 대리인 동의여부 확인, 불만처리 등 민원처리 , 고지사항 전달
o 마케팅 및 광고에 활용이벤트 등 광고성 정보 전달 , 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계`}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">■ 개인정보의 보유 및 이용기간</div>
        <div className="h7">
          원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체
          없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간
          동안 보존합니다.
        </div>
        <div className="h7">
          <LineBreaks
            text={`가. 회사 내부방침에 의한 정보보유 사유
회원이 탈퇴한 경우에도 불량회원의 부정한 이용의 재발을 방지, 분쟁해결 및 수사기관의 요청에 따른 협조를 위하여, 이용계약 해지일로부터 1년간 회원의 정보를 보유할 수 있습니다.`}
          />
        </div>
        <div className="h7">
          <LineBreaks
            text={`나. 관련 법령에 의한 정보 보유 사유전자상거래등에서의소비자보호에관한법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.
o 계약 또는 청약철회 등에 관한 기록
-보존이유 : 전자상거래등에서의소비자보호에관한법률
-보존기간 : 5년
o 대금 결제 및 재화 등의 공급에 관한 기록
-보존이유: 전자상거래등에서의소비자보호에관한법률
-보존기간 : 5년
o 소비자 불만 또는 분쟁처리에 관한 기록
-보존이유 : 전자상거래등에서의소비자보호에관한법률
-보존기간 : 3년
o 로그 기록
-보존이유: 통신비밀보호법
-보존기간 : 3개월`}
          />
        </div>
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">■ 개인정보의 파기절차 및 방법</div>
      <div className="h7">
        <LineBreaks
          text={`회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후, 보유기간의 경과 등 개인정보가 불필요하게 되었을 때에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다. 이용자가 원칙적으로 개인정보 수집 및 이용에 대한 동의(회원 가입, 계약 체결 등)를 철회(회원 탈퇴, 계약 해지 등)하는 경우, 회사는 수집한 이용자의 개인정보를 지체없이 파기합니다. 다만, 회원이 탈퇴한 경우에도 불량회원의 부정한 이용의 재발을 방지, 분쟁해결 및 수사기관의 요청에 따른 협조를 위하여, 이용계약 해지일로부터 1년간 회원의 정보를 보유할 수 있습니다.`}
        />
      </div>
      <div className="h7">
        <LineBreaks
          text={`o 파기절차
회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.`}
        />
      </div>
      <div className="h7">
        <LineBreaks
          text={`o 파기방법
전자적 파일형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. 종이문서에 출력∙기록 및 저장된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.`}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">■ 개인정보 제공</div>
        <div className="h7">
          <LineBreaks
            text={`회사는 이용자의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 이용자의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우 개인정보 보호법 제17조 제1항 제1호에 따라 정보주체의 동의를 얻어 필요 최소한의 범위로만 제공합니다.`}
          />
        </div>

        {/* 표 2 (제3자 제공) */}
        <SimpleTable cols={PROVIDER_COLS} rows={PROVIDER_DATA} />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">■ 수집한 개인정보의 위탁</div>
        <div className="h7">
          <LineBreaks
            text={`1. 회사는 이용자에게 보다 원활한 서비스를 제공하기 위하여 다음과 같이 개인정보 처리 관련 업무를 외부 전문업체에 위탁하고 있습니다.
o 위탁받는 자 : 짐풀
o 위탁업무 내용 : 배송 관련 업무 대행
2. 회사는 위탁계약 체결 시 위탁업무 수행목적 외 개인정보 처리금지, 기술적 관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리 및 감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 관리, 감독합니다.
3. 회사는 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체업싱 본 개인정보 처리방침을 통하여 이용자에게 알리겠습니다.`}
          />
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">■ 이용자 및 법정대리인의 권리와 그 행사방법</div>
        <div className="h7">
          회사는 만 14세 미만 아동의 회원가입을 받지 않으며, 개인정보 수집을
          하지 않습니다.
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">■ 개인정보의 안전성 확보 조치</div>
        <div className="h7">
          <LineBreaks
            text={`회사는 개인정보 보호법 제29조 및 같은 법 시행령 제30조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 취하고 있습니다.
O 관리적 조치
- 개인정보보호 지침(내부관리계획서) 수립∙시행, 정기적 직원 교육 등
O 기술적 조치
개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 패스워드, 신용정보 등의 암호화, 보안프로그램 설치 및 갱신, SSL을 통한 개인정보 암호화`}
          />
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">
          ■ 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항
        </div>
        <div className="h7">
          <LineBreaks
            text={`회사는 귀하의 정보를 수시로 저장하고 찾아내는 "쿠키(cookie)" 등을 운용합니다. 쿠키란 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다.`}
          />
        </div>
        <div className="h7">
          회사은(는) 다음과 같은 목적을 위해 쿠키를 사용합니다.
        </div>
        <div className="h7">
          <LineBreaks
            text={`o 쿠키 등 사용 목적
1. 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공
2. 귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.`}
          />
        </div>
        <div className="h7">
          <LineBreaks
            text={`o 쿠키 설정 거부 방법
1. 쿠키 설정을 거부하는 방법으로는 회원님이 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
2. 설정방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보
3. 단, 귀하께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.`}
          />
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">■ 개인정보에 관한 민원서비스</div>
        <div className="h7">
          <LineBreaks
            text={`회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보보호책임자를 지정하고 있습니다.
-고객서비스담당 부서
고객센터 전화번호 : 02-333-6525
이메일 : hello@granhand.com`}
          />
        </div>
        <div className="h7">
          <LineBreaks
            text={`- 개인정보관리책임자
성명 : 정루아
부서 : 브랜드 관리팀
전화번호 : 02-333-6525
이메일 : hello@granhand.com`}
          />
        </div>
        <div className="h7">
          <LineBreaks
            text={`o 귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호
관련 민원을 개인정보보호책임자 혹은 담당부서로 신고하실 수 있습니다. o 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
o 이용자는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
개인정보침해신고센터 (privacy.kisa.or.kr / 국번 없이 118)
개인정보분쟁조정위원회 (kopico.go.kr / 1833-6972)
대검찰청 사이버수사과 (spo.go.kr / 지역번호+1301)
경찰청 사이버안전국 (cyberbureau.police.go.kr / 국번없이 182)`}
          />
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div className="h6">■ 개인정보 처리방침 변경시 고지방법</div>
        <div className="h7">
          본 개인정보 처리방침은 아래 시행일로부터 적용되며, 법령 및 방침에 따른
          변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전에
          웹사이트 게시, 이메일 등을 통해 사전 공지하고, 사전공지가 곤란한 경우
          최대한 빠른 시간 내 고지할 것입니다.
        </div>
        <div className="h7">- 시행일 : 2025년 10월 21일</div>
      </div>
    </div>
  </div>
);

export const Marketing = () => {
  const { lang } = useLang();
  if (lang === "en") {
    return <EnMarketing />;
  } else return <KoMarketing />;
};

const EnMarketing = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      flex: 1,
    }}
  >
    <div className="h4">
      Consent to Receive Marketing and Promotional Information
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h7">
        JH Co., Ltd. (the “Company”) may send information regarding products,
        events, promotions, and special discounts to customers via email, text
        message (SMS/LMS), and app push notifications in order to provide
        various benefits and personalized services.
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">1. Purpose of Collection and Use</div>
      <div className="h7">
        <LineBreaks
          text={`o To provide information on new products and events\no To offer discounts and promotional benefits\no To conduct personalized marketing and promotional activities`}
        />
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">2. Items Collected</div>
      <div className="h7">
        Name, mobile phone number, email address, app push token, etc.
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">3. Retention and Use Period</div>
      <div className="h7">
        <LineBreaks
          text={`o In principle, personal information will be immediately destroyed upon membership withdrawal or revocation of consent.
o However, in accordance with Article 6 of the Act on Consumer Protection in Electronic Commerce, certain transaction records (such as contracts, payments, and delivery details) may be retained for a legally required period.
o Additionally, for risk management purposes (e.g., delayed delivery issues, points or benefits adjustment, dispute handling, or preventing repeated promotional abuse through re-registration), the Company may retain minimal information (such as transaction and activity records) for up to three (3) months after withdrawal.
o After this period, all related information will be destroyed without delay.`}
        />
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">4. Consequences of Refusal to Consent</div>
      <div className="h7">
        This consent is optional, and refusal will not affect the use of our
        services. However, if you do not consent, you may not receive
        notifications or benefits related to new products, events, and
        promotions.
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">5. Withdrawal of Consent</div>
      <div className="h7">
        You may withdraw your consent to receive marketing communications at any
        time through [My Page {">"} Notification Settings] or by contacting
        Customer Service, and all related messages will be stopped immediately
        upon withdrawal.
      </div>
    </div>
  </div>
);

const KoMarketing = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      flex: 1,
    }}
  >
    <div className="h4">마케팅 및 광고성 정보 수신 동의 안내</div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h7">
        (유)제이에이치는 고객님께 다양한 혜택과 맞춤형 서비스를 제공하기 위해
        상품 안내, 이벤트·프로모션, 할인 혜택 등의 정보를 이메일,
        문자메시지(SMS/LMS), 앱 푸시 등을 통해 발송할 수 있습니다.
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">1. 수집·이용 목적</div>
      <div className="h7">
        <LineBreaks
          text={`o 신상품 및 이벤트 안내\no 할인·혜택 정보 제공\no 맞춤형 마케팅 및 프로모션 활용 결제 정보`}
        />
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">2. 수집 항목</div>
      <div className="h7">이름, 휴대전화번호, 이메일 주소, 앱 푸시 토큰 등</div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">3. 보유 및 이용 기간</div>
      <div className="h7">
        <LineBreaks
          text={`o 원칙적으로 회원 탈퇴 또는 동의 철회 시 지체 없이 파기합니다.
o 단, 「전자상거래 등에서의 소비자보호에 관한 법률」 제6조에 따라 거래기록(계약·결제·배송 관련 기록 등)은 일정 기간 보존할 수 있습니다.
o 또한 운영 리스크 대응을 위해, 탈퇴 후 뒤늦게 발생할 수 있는 배송·포인트·분쟁 대응, 재가입을 통한 혜택 반복 수령 방지 등을 목적으로 최대 3개월간 최소한의 정보(거래 및 활동 기록 등)를 보관할 수 있습니다.
o 위 기간이 경과하면 해당 정보는 지체 없이 파기됩니다.`}
        />
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">4. 동의 거부 시 불이익</div>
      <div className="h7">
        본 동의는 선택 사항으로, 동의하지 않으셔도 서비스 이용에는 제한이
        없습니다. 다만, 동의를 거부하실 경우 신상품 소식, 이벤트 및 프로모션 등
        마케팅 혜택 안내를 받으실 수 없습니다.
      </div>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div className="h6">5. 동의 철회</div>
      <div className="h7">
        고객님은 언제든지 [마이페이지 - 알림 설정] 또는 고객센터를 통해 수신
        동의를 철회할 수 있으며, 철회 즉시 관련 발송은 중단됩니다.
      </div>
    </div>
  </div>
);
